import ProductAmountInput from './amount-input';

new ProductAmountInput({
	scope : '.product-card-component'
});

new ProductAmountInput({
	scope : '.product-detail'
});